import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { NotificationManager } from 'Components/Notifications';
import { createClipRequest } from '../api/requestVideoApi';
import { CLIP_LIST_QUERY_KEY } from '../utils/constants';
import { mapRequestError } from '../utils/requestError';

export const useCreateClipRequest = ({ onSubmitted } = {}) => {
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const mutation = useMutation({
    mutationFn: createClipRequest,
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: CLIP_LIST_QUERY_KEY });
      // The app's own toast, whichever view hosts the component.
      NotificationManager.success(
        formatMessage({ id: 'requestVideo_toast_body' }),
        formatMessage({ id: 'requestVideo_toast_title' }),
        3000,
        null,
        null,
        'success',
        null
      );
      if (onSubmitted) onSubmitted(result);
    },
  });

  let errorKind = null;
  if (mutation.isError) errorKind = mapRequestError(mutation.error);

  return {
    submit: mutation.mutate,
    reset: mutation.reset,
    isSending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    result: mutation.data,
    errorKind,
  };
};
